import { StoreId } from "../decorators/StoreIdDecorator";

class DownloadedImage {
  @StoreId
  storeId: string;
  blob: Blob;

  _objectUrl?: string;

  get objectUrl(): string {
    if (!this._objectUrl) {
      this._objectUrl = URL.createObjectURL(this.blob);
    }
    return this._objectUrl;
  }

  constructor(storeId: string, blob: Blob) {
    this.storeId = storeId;
    this.blob = blob;
  }

  /** Return string to use as backgroundImage key. Ensures refresh if span state changes */
  getBackgroundKey(): string {
    return this.objectUrl;
  }
}

export { DownloadedImage };
